<template>
  <div>
    <div v-if="!dataLoaded">
      <b-card title="فاکتور ها">
        <b-card-text>
          <b-skeleton type="button"></b-skeleton>
          <div class="mt-3">
            <b-skeleton-table
              :rows="10"
              :columns="7"
              :table-props="{ bordered: true, striped: true }"
            ></b-skeleton-table>
          </div>
        </b-card-text>
      </b-card>
    </div>
    <div v-if="dataLoaded">
      <b-modal id="modal-1" title="جستجو" @ok="filterData()"   ok-title="جستجو"
        cancel-title="انصراف">
        <b-form-group id="input-group-2" label="وضعیت: " label-for="input-2">
          <MDDropdown v-bind:group="106" v-model="search.status"></MDDropdown>
        </b-form-group>
      </b-modal>
      <b-card title="فاکتور ها">
        <b-card-text>
          <b-button class="mt-3" variant="success" @click="addNew()"
            >جدید</b-button
          >
          <b-button class="mt-3 ml-3" variant="success" v-b-modal.modal-1
            >جستجو</b-button
          >
          <b-table
          responsive
            class="mt-3"
            striped
            hover
            show-empty
            empty-text="آیتمی جهت نمایش وجود ندارد"
            :fields="fields"
            :items="List"
          >
            <template v-slot:cell(details)="row">
              <span>
                <b-link
                  variant="success"
                  :href="'https://she.pa/factor/' + row.item.id"
                  >&nbsp;&nbsp;جزییات&nbsp;</b-link
                >
                |
              </span>

              <span v-if="row.item.mdid106_status == 1674">
                <b-link variant="success" :href="'Addfactor/' + row.item.id"
                  >&nbsp;&nbsp;ویرایش&nbsp;</b-link
                >|
              </span>
              <span v-if="row.item.mdid106_status == 1674">
                <b-link
                  v-if="row.item.mdid106_status == 1674"
                  variant="success"
                  @click="deletem(row.item.id)"
                  >&nbsp;&nbsp;حذف</b-link
                >
              </span>
            </template>
          </b-table>
        </b-card-text>
      </b-card>
      <b-modal
        ref="delete-modal"
        ok-title="تایید"
        cancel-title="انصراف"
        @ok="handleOk"
        title="حذف"
        >آیا مایل به حذف آیتم مورد نظر می باشید؟</b-modal
      >
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import httpHelper from "@/helpers/httpHelper";
import sessionHelper from "../../helpers/sessionHelper";
import persianDate from "../../helpers/persianDate";
import MDDropdown from "../../components/MDDropdown";
export default {
  name: "factors",
  data: function () {
    return {
      dataLoaded: false,
      List: [],
      fields: [
        {
          key: "id",
          label: "شماره",
        },
        {
          key: "customer_name",
          label: "نام مشتری",
        },
        {
          key: "customer_mobile",
          label: "موبایل مشتری",
        },
        {
          key: "due_date",
          label: "تاریخ سررسید",
        },
        {
          key: "expire_date",
          label: "تاریخ انقضا",
        },
        {
          key: "status",
          label: "وضعیت",
        },
        {
          key: "details",
          label: "جزییات",
        },
      ],
      selected_item: 0,

      search: {
        status: 0,
      },
    };
  },
  components: {
    MDDropdown,
  },
  created() {
    this.filterData();
  },
  methods: {
    addNew: function () {
      this.$router.push({ name: "Addfactor" });
    },
    handleOk: function () {
      httpHelper.getData("factor/" + this.selected_item).then((res) => {
        if (res.success) {
          //this.List.splice(this.List.indexOf(this.selected_item), 1);
          this.filterData();
        }
      });
    },
    deletem: function (selectedItem) {
      this.selected_item = selectedItem;
      this.$refs["delete-modal"].show();
    },
    filterData: function () {
      var params = "";

      if (this.search.status) {
        params += "&mdid106_status=" + this.search.status;
      }
      httpHelper.setAuth();
      httpHelper
        .getData("factor?t=1" + params)
        .then((res) => {
          this.List = res.result.data;
          this.dataLoaded = true;
          this.List = this.List.map((item) => {
            return {
              id: item.id,
              customer_name: item.customer_name,
              customer_mobile: item.customer_mobile,
              status: item.status.title,
              mdid106_status: item.status.id,
              due_date: persianDate.getDateByFormat(item.due_date),
              expire_date: persianDate.getDate(item.expire_date),
              /*moment(item.created_at, 'YYYY-MM-DDTHH:mm:ss.ZZ').locale('fa').format('YYYY/MM/DD')*/
            };
          });
        })
        .finally(() => {});
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "فاکتورها" }]);
  },
};
</script>
